export default __webpack_public_path__ + "static/media/singUp.8fa5d8fa.png";